import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormatPrice from '@shared/containers/FormatPrice';

const PricePerMeasurementContainer = styled.span`
  font-size: 10px;
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  color: ${({ theme }) => theme.colors.night_blue_60};
  padding: 6px 0 0 0;
`;
function PricePerUnit({
  pricePerMeasurement,
  measurementItems,
  measurementUnitId,
}) {
  const itemPlural = useMemo(
    () => measurementItems?.find(m => m.id === measurementUnitId)?.shortName,
    [measurementItems, measurementUnitId],
  );

  return (
    !!itemPlural &&
    !!pricePerMeasurement && (
      <PricePerMeasurementContainer>
        <FormatPrice value={pricePerMeasurement} />/{itemPlural}
      </PricePerMeasurementContainer>
    )
  );
}

PricePerUnit.propTypes = {
  pricePerMeasurement: PropTypes.number,
  measurementItems: PropTypes.array,
  measurementUnitId: PropTypes.number,
};

export default PricePerUnit;
